<ng-container>
  <div class="summary-result" id="question{{ data?.sequence_id }}">
    <!-- Result Header -->
    <div class="summary-header">
      <div class="summary-title-wrapper">
        <div class="summary-icon">
          <i class="fa fa-file-text-o"></i>
        </div>

        <div class="summary-title-content">
          <span class="summary-label">AI Summary</span>
          <span class="summary-subtitle">Generated from your content</span>
        </div>
      </div>

      <div class="summary-status">
        <i class="fa fa-check-circle"></i>
        <span>Completed</span>
      </div>
    </div>

    <!-- Summary Content -->
    @if (summary.bot_answer) {
    <div class="summary-body">
      <div class="summary-content">
        <div class="content-heading">
          <span class="heading-icon">
            <i class="fa fa-lightbulb-o"></i>
          </span>
          <span>Summary</span>
        </div>
        <div class="answer-content" [innerHTML]="changeNewLine(summary)"></div>
      </div>
    </div>
    <!-- Footer -->
    <div class="summary-footer">
      <div class="timestamp-wrapper">
        <i class="fa fa-clock-o timestamp-icon"></i>
        <span class="timestamp-text">
          {{ summary.created_at | date : "MMM d, y, h:mm a" }}
        </span>
      </div>
      <div class="generated-label">
        <i class="fa fa-magic"></i>
        AI Generated
      </div>
    </div>
    }
  </div>
</ng-container>
